import { Product } from '~shared/models';
import { ArraySerializer, Field, Type, deserialize } from 'serialize-ts';
import { ModelMetadataSerializer } from 'serialize-ts/dist/serializers/model-metadata.serializer';
import { Category } from '~app/modules/generic/models/category.model';

export enum SuggestionTypes {
  text = 'text',
  category = 'category',
}

export class SuggestionAttribute {

  @Field()
  id?: string;

  @Field()
  name?: string;

  @Field()
  slug?: string;

  @Field()
  @Type(new ModelMetadataSerializer(Category))
  parent?: Category;
}

export class Suggestion {

  @Field()
  value: string;

  @Field()
  type?: SuggestionTypes;

  @Field()
  @Type(new ModelMetadataSerializer(SuggestionAttribute))
  attrs?: SuggestionAttribute;
}

export class SuggestionsResponse {

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Suggestion)))
  suggestions: Suggestion[];

  @Field()
  @Type(new ArraySerializer(new ModelMetadataSerializer(Product)))
  products: Product[];

  public static map(response: any): SuggestionsResponse {
    const suggestionResponse = deserialize(response, SuggestionsResponse);
    suggestionResponse.products = suggestionResponse.products || [];
    return suggestionResponse;
  }
}
